import  Date from "react-datepicker"
import React from 'react'
import { FormControl } from "react-bootstrap";

interface Iprops{
    name?:any;
    disabled?:any;
    showMonthYearPicker?:any;
    dateFormat?:any;
    selected?:any;
    onChange?:any;
    value?:any;
    placeholderText?:any;
    autoComplete?:any;
    showTimeSelect?:any;
    showTimeSelectOnly?:any;
    timeIntervals?:any;
    timeCaption?:any;
    timeFormat?:any;
    className?: any;
    minDate?:any;
    maxDate?:any;
    customInput?:any;
}
export default function DatePicker(props:Iprops) {
    return (
        <div style={{"padding":"5px"}}>
        <Date
        disabled={props.disabled}
        name={props.name}
        showTimeSelect={props.showTimeSelect}
        showTimeSelectOnly={props.showTimeSelectOnly}
        timeIntervals={props.timeIntervals}
        timeCaption={props.timeCaption}
        timeFormat={props.timeFormat}
        showMonthYearPicker={props.showMonthYearPicker}
        dateFormat={props.dateFormat}
        selected={props.selected}
        onChange={props.onChange}
        placeholderText={props.placeholderText}
        customInput={props?.customInput ? props?.customInput : <FormControl value={props.value} />}
        autoComplete={"off"}
        minDate={props.minDate}
        maxDate={props.maxDate}
        className={props.className}
      />
      </div>
    )
}
